import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const LinkComponent = () => {
    const { id1, id2, id3, id4 } = useParams();
    const { t } = useTranslation();

    // Create an array of IDs
    const ids = [id1, id2, id3, id4];

    // Helper function to format ID
    const formatId = (id) => {
        if (!id) return '';
        return id
            .split('-') // Split by dash
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize first letter of each word
            .join(' '); // Join back with space
    };

    // Find the last non-empty ID index
    const lastIdIndex = ids.map((id) => Boolean(id)).lastIndexOf(true);

    const fadeInUp = (delay = 0) => ({
        initial: {
            translateY: -10,
            opacity: 0,
        },
        animate: {
            translateY: 0,
            opacity: 1,
            transition: {
                duration: 1,
                delay: delay,
            },
        },
    });

    return (
        <div className="w-full ">
            <div className="flex text-14 flex-wrap font-light">
                <motion.div variants={fadeInUp(0)} initial="initial" animate="animate">
                    <Link
                        to={`/`}
                        className={`opacity-50 hover:border-b hover:border-b-black transition-all duration-300 hover:opacity-100 cursor-pointer`}
                    >
                        /{t("breadcrumb.home")}&nbsp;
                    </Link>
                </motion.div>

                <motion.div variants={fadeInUp(0.2)} initial="initial" animate="animate">
                    <Link
                        to={`/urunler`}
                        className={`${
                            lastIdIndex !== -1 ? 'opacity-50' : 'opacity-100'
                        } hover:border-b hover:opacity-100 hover:border-b-black transition-all duration-300 cursor-pointer`}
                    >
                        /{t("breadcrumb.products")}&nbsp;
                    </Link>
                </motion.div>
                
                {ids.map((id, index) => {
                    const formattedId = formatId(id);
                    const isActive = lastIdIndex === index; 
                    return (
                        <motion.div
                            key={index}
                            variants={fadeInUp((index + 1) * 0.2)}
                            initial="initial"
                            animate="animate"
                        >
                            <Link
                                to={`/urunler/${ids.slice(0, index + 1).join('/')}`}
                                className={`${
                                    isActive ? 'opacity-100' : 'opacity-50'
                                } hover:border-b hover:opacity-100 hover:border-b-black transition-all duration-300 cursor-pointer`}
                            >
                                {formattedId ? `/${formattedId}` : ''}&nbsp;
                            </Link>
                        </motion.div>
                    );
                })}
            </div>
        </div>
    );
};

export default LinkComponent;